export class TemplateEmail {
  id: number;
  nome: string;
  assunto: string;
  texto: string;
  tipo: number;

  anexos: AnexoTemplateEmail[];
}

export class AnexoTemplateEmail {
  id: number;
  idTemplateEmail: number;
  tipo: number;
  arquivo: string;
  idProposta: number;
  excluir: boolean;
  file: File;
}
